import { Controller } from 'stimulus';

export default class ShowController extends Controller {
  addItem(event) {
    const id = event.currentTarget.value;
    const elementToMove = this.disabledPlaylistsTarget.querySelector(`#module-${id.replace(/:/g, '\\:')}`);
    this.activePlaylistsTarget.appendChild(elementToMove);
    event.currentTarget.remove(event.currentTarget.selectedIndex);
    event.currentTarget.selectedIndex = 0;
    event.currentTarget.blur();
    this.validateDataCollectionModule(elementToMove);
  }

  removeItem(event) {
    const elementToMove = event.currentTarget.closest("[draggable]");
    this.disabledPlaylistsTarget.appendChild(elementToMove);
    this.dropdownTarget.add(new Option(elementToMove.dataset.name, elementToMove.id.replace("module-", ""), false, false));
  }

  validateDataCollection(event) {
    if (event && event.target) {
      const moduleContainer = event.target.closest('[draggable]');
      if (moduleContainer) {
        this.validateDataCollectionModule(moduleContainer);
        return;
      }
    }

    if (!this.hasActivePlaylistsTarget) return;

    const checkbox =
      this.collectPhoneTargets.find((el) => this.activePlaylistsTarget.contains(el)) ||
      this.collectAddressTargets.find((el) => this.activePlaylistsTarget.contains(el));
    if (!checkbox) return;

    const moduleContainer = checkbox.closest('[draggable]');
    if (!moduleContainer) return;
    this.validateDataCollectionModule(moduleContainer);
  }

  validateDataCollectionModule(moduleContainer) {
    const phoneCheckbox = this.collectPhoneTargets.find((el) => moduleContainer.contains(el));
    const addressCheckbox = this.collectAddressTargets.find((el) => moduleContainer.contains(el));

    if (!phoneCheckbox || !addressCheckbox) return;

    const message = phoneCheckbox.checked || addressCheckbox.checked ? '' : 'Select at least one option.';
    phoneCheckbox.setCustomValidity(message);
    addressCheckbox.setCustomValidity(message);
  }
}

ShowController.targets = ["activePlaylists", "disabledPlaylists", "dropdown", "collectPhone", "collectAddress"];